import { useState } from "react";

import Circle from "@/components/Circle";
import { theme } from "@/core/theme";
import Group from "@/tpo/Group";
import Menu, { Button } from "@/tpo/Menu";

export default function MultiSelectCircleDropdown({
  label,
  options = [],
  onChange,
  value = [],
  placeholder = "Select options...",
  trigger = "click",
  disabled = false,
  singleSelect = false,
  buttonProps = {},
  dropdownProps = {},
  ...rest
}) {
  const [showMenu, setShowMenu] = useState(false);

  const handleToggle = optionValue => {
    if (disabled) return;
    if (singleSelect) {
      // For single select, just select the option and close the menu
      onChange([optionValue]);
      setShowMenu(false);
    } else {
      // For multi select, toggle the option
      if (value.includes(optionValue)) {
        onChange(value.filter(v => v !== optionValue));
      } else {
        onChange([...value, optionValue]);
      }
    }
  };

  return (
    <Menu
      opened={showMenu}
      onChange={setShowMenu}
      trigger={trigger}
      allowedPlacements={["bottom", "bottom-start"]}
      {...rest}
    >
      <Menu.Target>
        <Button
          open={showMenu}
          color="dark"
          disabled={disabled}
          sx={{
            color: "white",
            px: [20, 20, 40],
            fontSize: [14, 14, 16],
            fontFamily: "gilroyRegular",
            textTransform: "unset",
            letterSpacing: "unset",
            opacity: disabled ? 0.6 : 1,
            cursor: disabled ? "not-allowed" : "pointer",
            minWidth: 200,
            maxWidth: 400,
            width: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            ...(buttonProps.sx || {})
          }}
        >
          {label || placeholder}
        </Button>
      </Menu.Target>
      <Menu.Dropdown
        mt={2}
        py={2}
        zIndex={200000000}
        minWidth={200}
        maxHeight={300}
        overflow="auto"
        bg="dark"
        {...dropdownProps}
      >
        {options.map(option => {
          const isSelected = value.includes(option.value);

          return (
            <Menu.Item
              onClick={() => handleToggle(option.value)}
              selected={singleSelect && isSelected}
              key={option.value}
              fontSize={14}
              lineHeight={1.7}
              py={16}
              px={20}
              color="white"
              selectedColor="rgba(255, 255, 255, 0.10)"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              keepOpen
            >
              <Group gap={10} alignItems="center" flex={1} color="inherit">
                {option.content || option.label}
              </Group>
              {!singleSelect && (
                <Circle
                  size={38}
                  backgroundColor={isSelected ? 'green' : "transparent"}
                  withBorder={!isSelected}
                  borderColor={theme.colors.white}
                  flexShrink={0}
                  style={{
                    outlineOffset: 2,
                    outline: `1px solid ${theme.colors.green}`
                  }}
                />
              )}
            </Menu.Item>
          );
        })}
      </Menu.Dropdown>
    </Menu>
  );
}
